import { useEffect, useState } from 'react';
import { Layout } from '@/components/layout/Layout';
import { cmsApi } from '@/lib/api';
import { Loader2, Twitter, Linkedin, Mail, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { TacticalMotif } from '@/components/tactical/PitchBackground';

const HakkindaPage = () => {
  const [content, setContent] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await cmsApi.getAbout();
        setContent(res.body_html || '');
      } catch (error) {
        console.error('Failed to load about page content:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  if (loading) {
    return (
      <Layout>
        <div className="flex items-center justify-center min-h-[60vh]">
          <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
        </div>
      </Layout>
    );
  }

  return (
    <Layout>
      <section className="container-wide py-12 sm:py-16">
        <div
          className="prose prose-invert max-w-none article-content"
          dangerouslySetInnerHTML={{ __html: content }}
        />
      </section>

    </Layout>
  );
};

export default HakkindaPage;
